import { render, staticRenderFns } from "./ManualRoomAllocateList.vue?vue&type=template&id=4437e8da&"
import script from "./ManualRoomAllocateList.vue?vue&type=script&lang=js&"
export * from "./ManualRoomAllocateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports